import { render, staticRenderFns } from "./esqueciEsenha.vue?vue&type=template&id=27e0ba54&scoped=true&"
import script from "./esqueciEsenha.vue?vue&type=script&lang=js&"
export * from "./esqueciEsenha.vue?vue&type=script&lang=js&"
import style0 from "./esqueciEsenha.vue?vue&type=style&index=0&id=27e0ba54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0ba54",
  null
  
)

export default component.exports